/* Cloofs – Beleidspagina's (sections/cloofs-policy): een alinea die alleen uit een vetgedrukte regel bestaat
   ("Verzendkosten") krijgt de opmaak van een tussenkop (kenmerk data-heading). De tekst zelf verandert niet. Geladen met defer. */
document.querySelectorAll('[data-policy-body]').forEach((body) => {
  body.querySelectorAll('p').forEach((p) => {
    const strong = p.querySelector(':scope > strong, :scope > b, :scope > span > strong, :scope > span > b');
    const text = p.textContent.trim();
    if (strong && text.length > 1 && text.length < 120 && text === strong.textContent.trim()) p.setAttribute('data-heading', '');
  });
});
